import { render, staticRenderFns } from "./ConfiguratorLevel1Mobile.vue?vue&type=template&id=8bd70352&scoped=true&"
import script from "./ConfiguratorLevel1Mobile.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorLevel1Mobile.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorLevel1Mobile.vue?vue&type=style&index=0&id=8bd70352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd70352",
  null
  
)

export default component.exports